<template>
  <template v-if="columns && columns.length > 1">
    <tr
      class="combobox-item"
      :class="{
        parent: item.isParent,
        selected: selectedValue === item[valueField],
        active: activeValue == item[valueField],
      }"
      @click="onItemClick(item, $event)"
    >
      <td
        v-for="(column, tdIndex) in columns"
        :ref="`td-${tdIndex}`"
        :key="column.dataField"
        class="combobox-item-td"
        :class="tdIndex === 0 ? `level-${item.level}` : null"
      >
        <div class="flex-row align-center combobox-item-td--contents" :style="getCellStyle(column, tdIndex)">
          <div
            v-if="tdIndex === 0"
            class="icon16"
            :class="{
              collapse: !item.expanded,
              expand: item.expanded,
              invisible: !item.childNodes || item.childNodes.length === 0,
            }"
            @click="toogleExpand(item, $event)"
          ></div>
          <div class="flex item-text combobox-item-td--text" :title="getItemDisplay(item, column)">
            {{ getItemDisplay(item, column) }}
          </div>
        </div>
      </td>
    </tr>

    <template v-if="item.expanded">
      <ms-combobox-tree-item
        v-for="child in item.childNodes"
        :key="child[valueField]"
        :item="child"
        :columns="columns"
        :value-field="valueField"
        :display-field="displayField"
        :selected-value="selectedValue"
        :active-value="activeValue"
        @item-click="onItemClick"
        @toogle-expand="onChildToogleExpand"
      />
    </template>
  </template>
  <div v-else>
    <!-- :data="JSON.stringify(item)" -->
    <a
      class="combobox-item-con combobox-item-tree single d-block"
      :class="[
        {parent: item.isParent, selected: selectedValue === item[valueField], active: activeValue == item[valueField]},
      ]"
      :style="'text-align: ' + align"
      @click="onItemClick(item, $event)"
    >
      <div class="combobox-item--text flex-row" :title="item[displayField]">
        <!-- v-if="item.childNodes && item.childNodes.length > 0" -->
        <div
          class="tree-icon icon16"
          :class="{
            collapse: item.expanded,
            expand: !item.expanded,
            invisible: !item.childNodes || item.childNodes.length === 0,
          }"
          @click="toogleExpand(item, $event)"
        ></div>
        <!-- , invisible: !item.childNodes || item.childNodes.length === 0 -->
        <div :class="{'flex item-text': item, bold: item.childNodes}">
          {{ item[displayField] }}
        </div>
        <!-- <div class="flex item-text">{{ JSON.stringify(item) }}</div> -->
      </div>
    </a>

    <div v-if="item.expanded" class="dropdown-items childs">
      <ms-combobox-tree-item
        v-for="child in item.childNodes"
        :key="child[valueField]"
        :item="child"
        :columns="columns"
        :value-field="valueField"
        :display-field="displayField"
        :selected-value="selectedValue"
        :active-value="activeValue"
        @item-click="onItemClick"
        @toogle-expand="onChildToogleExpand"
      />
    </div>
  </div>
</template>

<script>
import {defineComponent, getCurrentInstance} from 'vue';
import {MSConstant} from '@/commons/wildcards';

export default defineComponent({
  name: 'MsComboboxTreeItem',
  emits: ['itemClick', 'toogleExpand'], // khai báo emit event
  props: {
    /**
     * truyền từ combobox để xem đang select bản ghi nào
     */
    selectedValue: {},
    /**
     * Item sử dụng để binding
     */
    item: {},

    /**
     * Cấu hình cột của menu
     */
    columns: {
      type: Array,
      default: new Array(),
    },

    /**
     * Trường làm value
     * CreatedBy PDKIEN 10/12/2019
     */
    valueField: {
      type: String,
      default: null,
    },
    /**
     * Trường là display
     * CreatedBy PDKIEN 10/12/2019
     */
    displayField: {
      type: String,
      default: null,
    },
    /**
     * Kiểu định dạng dữ liệu trên combobox
     * Tương ứng với FormatType
     * CreatedBy PDKIEN 07/12/2019
     */
    formatType: {
      type: [Number, String],
      default: null,
    },
    align: {
      type: String,
      default: 'left',
    },
    /**
     * item active
     * truyền qua để gán style
     */
    activeValue: {},
  },
  setup(props, {emit}) {
    // Variable
    const {proxy} = getCurrentInstance();

    const onItemClick = (item, e) => {
      if (e.cancel) {
        return;
      }

      emit('itemClick', item, e);
    };

    // Method
    /**
     * Hàm lấy style cho td trong table
     * dữ liệu động theo config của dev
     */
    const getCellStyle = (column, index) => {
      if (column.isResize) {
        if (proxy.$refs[`td-${index}`] && proxy.$refs[`td-${index}`].length > 0) {
          const item = proxy.$refs[`td-${index}`][0];
          const rectTd = item.getBoundingClientRect();
          const rectParent = proxy.$parent.$el.getBoundingClientRect();
          if (rectTd.right <= rectParent.right) {
            return {
              width: rectTd.width + (rectParent.right - rectTd.right) + 'px',
              textAlign: column.columnAlign,
            };
          } else {
            return {
              width: `${column.width}px`,
              textAlign: column.columnAlign,
            };
          }
        }
      }
      return {
        width: column.isResize ? null : `${column.width}px`,
        textAlign: column.columnAlign,
      };
    };

    /**
     * Lấy text hiển thị trên item tree
     * Nếu có column lấy theo column.field, nếu không có column lấy theo displayField, nếu không có displayField lấy theo valueField
     * CreatedBy PDKIEN 10/12/2019
     */
    const getItemDisplay = (item, column) => {
      const field = column ? column.dataField : props.displayField || props.valueField;

      let value = '';
      if (field) {
        value = item[field];
      } else {
        value = item;
      }

      if (column && column.formatType) {
        switch (column.formatType) {
          case MSConstant.FormatType.Date:
            if (value) {
              value = proxy.$ms.format.formatData(value, {
                formatType: column.formatType,
              });
            }
            break;
          case MSConstant.FormatType.Enum:
            if (value) {
              value = proxy.$ms.format.formatData(value, {
                formatType: column.formatType,
                enumName: column.enum,
              });
            }
        }
      }
      return value;
    };

    const toogleExpand = (item, e) => {
      e.preventDefault();
      e.cancel = true;
      item.expanded = !item.expanded;

      emit('toogleExpand', item, item.expanded);
    };

    const onChildToogleExpand = (item, expanded) => {
      emit('toogleExpand', item, expanded);
    };

    return {
      toogleExpand,
      getCellStyle,
      getItemDisplay,
      onItemClick,
      onChildToogleExpand,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsComboboxTreeItem.scss';

.active {
  background: $bg-row-active;
  color: $text-primary;
}

.align-center {
  align-items: center;
}
</style>
